<template>
  <div class="nav-bar">
    <img class="nav-bar__logo" src="@/assets/components/nav-bar/aibee-logo.svg">
    <div v-for="(item, index) in menu"
         :key="index"
         class="nav-bar__button"
         :class="{
           'nav-bar__button--active': currentMenu === item.route,
           'nav-bar__button--disabled': item.route.length === 0
         }"
         @click="jumpTo(item.route)">
      {{ item.title }}
    </div>
    <div class="action">
      <div class="nav-bar__button nav-bar__button--help nav-bar__button--disabled">
        <i class="material-icons">help_outline</i>帮助
      </div>
      <div class="nav-bar__button nav-bar__button--help" @click="logout">
        <i class="material-icons">face</i>用户名(登出)
      </div>
    </div>
  </div>
</template>

<script>
import Menu from '@/consts/menu';

export default {
  name: 'NavBar',
  data() {
    return {
      menu: Menu
    };
  },
  computed: {
    currentMenu() {
      const routes = (/(?:\/x)(\/[^/]+)(?:\/[^/]+)?/g).exec(this.$route.path);
      return routes && routes.length > 1 ? routes[1] : '';
    }
  },
  mounted() {
  },
  methods: {
    jumpTo(route) {
      if (route && route.length) this.$router.push(`/x${route}`);
    },
    async logout() {
      try {
        const { data } = await this.$http.post('/admin/logout');
        if (data.error_no === 200) {
          this.$router.replace('/login');
        }
      } catch (e) {
        // something went wrong
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.nav-bar {
  width: calc(100% - 120px);
  height: 61px;
  min-width: 1160px;
  background-color: #424242;
  color: #989898;
  border-bottom: 1px solid black;
  padding: 0 60px;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  box-shadow: 0 0 7px 3px rgba(0, 0, 0, .4);
  z-index: 10;

  &__logo {
    display: inline-block;
    width: 100px;
    height: 30px;
    margin: 0 30px 0 10px;
  }

  &__button {
    height: 100%;
    display: inline-flex;
    width: 120px;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    cursor: pointer;
    transition: .2s;
    user-select: none;

    &:hover {
      color: #bcbcbc;
    }

    &--active {
      color: #fafafa;

      &:hover {
        color: #fafafa;
        cursor: auto;
      }
    }

    &--disabled {
      &:hover {
        cursor: not-allowed;
        color: #989898;
      }
    }

    .material-icons {
      font-size: 16px;
      margin-right: 6px;
    }
  }
}

.action {
  position: absolute;
  right: 60px;
  top: 0;
  height: 61px;
}
</style>
